import axiosInstance from './axiosConfig';
import { createCancelToken } from './axiosUtils';

const AccountAPI = {
  getAll: function ({ org_id, ...params }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/accounts`,
      params: params,
      cancelToken: cancelTokenObject[this.getAll.name].requestCancellation().token,
    });
  },
  inviteUsers: function (org_id, emails, role) {
    return axiosInstance.request({
      method: 'POST',
      url: `/organizations/${org_id}/invites`,
      data: { email: emails, role },
    });
  },
  delete: function (org_id, account_id) {
    return axiosInstance.request({
      method: 'DELETE',
      url: `/organizations/${org_id}/org-members/${account_id}`,
    });
  },
  update: function ({ org_id, account_id, ...data }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/organizations/${org_id}/org-members/${account_id}`,
      data: data,
    });
  },
  getById: function (org_id, account_id) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/org-members/${account_id}`,
    });
  },
  reinviteUser: function (org_id, account_id) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/organizations/${org_id}/invites/${account_id}/re-invite`,
    });
  },
  check: function (token) {
    delete axiosInstance.defaults.headers.common['Authorization'];
    return axiosInstance.request({
      method: 'GET',
      url: `/users/check-account-existed`,
      params: { token },
    });
  },
  acceptInvite: function (token) {
    return axiosInstance.request({
      method: 'POST',
      url: `/users/accept-invite`,
      params: { token },
    });
  },
  createUserByInvitation: function (data) {
    delete axiosInstance.defaults.headers.common['Authorization'];
    return axiosInstance.request({
      method: 'POST',
      url: `/users`,
      data: data,
    });
  },
  changeRole: function ({ org_id, account_id, role, password }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/organizations/${org_id}/org-members/${account_id}/change-role`,
      data: { role, password },
    });
  },
};

const cancelTokenObject = createCancelToken(AccountAPI);
export default AccountAPI;
